"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchNutritionTargetMode = exports.sumNutrition = exports.storedNutritionValues = exports.scaleNutrition = exports.resolveNutritionTargets = exports.recipeCompositionNutrition = exports.nutritionTargetsError = exports.nutritionScheduleTotals = exports.nutritionPlanWeeks = exports.nutritionPlanTotals = exports.nutritionPlanTargetsValid = exports.nutritionNumber = exports.nutritionFields = exports.mealCompositionNutrition = exports.macroEnergyPercentages = exports.ingredientNutrition = exports.compositionNutrition = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Ingredients are per 100 g; recipe and meal values are full-composition totals.
var nutritionFields = exports.nutritionFields = ['caloriesKcal', 'proteinG', 'carbG', 'fatG', 'fiberG', 'sugarG'];

// Recipe/meal inputs store the original five fields only; sugars are live-derived.
var storedNutritionValues = exports.storedNutritionValues = function storedNutritionValues(values) {
  return Object.fromEntries(nutritionFields.filter(function (field) {
    return field !== 'sugarG';
  }).map(function (field) {
    return [field, values[field]];
  }));
};
var nutritionNumber = exports.nutritionNumber = function nutritionNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  var number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
};
var ingredientNutrition = exports.ingredientNutrition = function ingredientNutrition(ingredient) {
  return {
    caloriesKcal: ingredient === null || ingredient === void 0 ? void 0 : ingredient.caloriesKcal,
    proteinG: ingredient === null || ingredient === void 0 ? void 0 : ingredient.proteinsG,
    carbG: ingredient === null || ingredient === void 0 ? void 0 : ingredient.carbohydratesG,
    fatG: ingredient === null || ingredient === void 0 ? void 0 : ingredient.fatsG,
    fiberG: ingredient === null || ingredient === void 0 ? void 0 : ingredient.fiberG,
    sugarG: ingredient === null || ingredient === void 0 ? void 0 : ingredient.sugarG
  };
};

// No rounding here: round only for display, never between calculation levels.
var scaleNutrition = exports.scaleNutrition = function scaleNutrition(values, factor) {
  return Object.fromEntries(nutritionFields.map(function (field) {
    var value = nutritionNumber(values === null || values === void 0 ? void 0 : values[field]);
    return [field, value === null || !Number.isFinite(factor) || factor < 0 ? null : value * factor];
  }));
};
var sumNutrition = exports.sumNutrition = function sumNutrition(values) {
  return Object.fromEntries(nutritionFields.map(function (field) {
    var numbers = values.map(function (value) {
      return nutritionNumber(value === null || value === void 0 ? void 0 : value[field]);
    });
    return [field, !numbers.length || numbers.some(function (value) {
      return value === null;
    }) ? null : numbers.reduce(function (sum, value) {
      return sum + value;
    }, 0)];
  }));
};
var macroEnergyPercentages = exports.macroEnergyPercentages = function macroEnergyPercentages(values) {
  var grams = ['proteinG', 'carbG', 'fatG'].map(function (field) {
    return nutritionNumber(values === null || values === void 0 ? void 0 : values[field]);
  });
  if (grams.some(function (value) {
    return value === null;
  })) return null;
  var energy = grams.map(function (value, index) {
    return value * (index === 2 ? 9 : 4);
  });
  var total = energy.reduce(function (sum, value) {
    return sum + value;
  }, 0);
  return total > 0 ? {
    protein: energy[0] / total * 100,
    carbs: energy[1] / total * 100,
    fat: energy[2] / total * 100
  } : null;
};
var nutritionTargetsError = exports.nutritionTargetsError = function nutritionTargetsError() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var targets = values || {};
  if (targets.macroMode === 'percent') {
    if (!(nutritionNumber(targets.kcal) > 0)) return 'energy';
    var shares = ['proteinPercent', 'carbsPercent', 'fatPercent'].map(function (key) {
      return nutritionNumber(targets[key]);
    });
    if (shares.some(function (value) {
      return value === null || value > 100;
    })) return 'percentages';
    if (Math.abs(shares.reduce(function (sum, value) {
      return sum + value;
    }, 0) - 100) > 0.01) return 'total';
  } else if (['kcal', 'proteinG', 'carbsG', 'fatG'].some(function (key) {
    return targets[key] !== null && targets[key] !== undefined && targets[key] !== '' && nutritionNumber(targets[key]) === null;
  })) return 'grams';
  return null;
};
var resolveNutritionTargets = exports.resolveNutritionTargets = function resolveNutritionTargets() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var targets = values || {};
  if (targets.macroMode !== 'percent') return targets;
  if (nutritionTargetsError(targets)) return _objectSpread(_objectSpread({}, targets), {}, {
    proteinG: null,
    carbsG: null,
    fatG: null
  });
  return _objectSpread(_objectSpread({}, targets), {}, {
    proteinG: Number(targets.kcal) * Number(targets.proteinPercent) / 400,
    carbsG: Number(targets.kcal) * Number(targets.carbsPercent) / 400,
    fatG: Number(targets.kcal) * Number(targets.fatPercent) / 900
  });
};
var switchNutritionTargetMode = exports.switchNutritionTargetMode = function switchNutritionTargetMode(targets, mode) {
  var resolved = resolveNutritionTargets(targets);
  if (mode === 'grams') return _objectSpread(_objectSpread({}, resolved), {}, {
    macroMode: mode
  });
  var shares = macroEnergyPercentages({
    proteinG: resolved.proteinG,
    carbG: resolved.carbsG,
    fatG: resolved.fatG
  });
  var proteinPercent = shares ? Math.round(shares.protein * 10) / 10 : null;
  var carbsPercent = shares ? Math.round(shares.carbs * 10) / 10 : null;
  return resolveNutritionTargets(_objectSpread(_objectSpread({}, targets), {}, {
    macroMode: mode,
    proteinPercent: proteinPercent,
    carbsPercent: carbsPercent,
    fatPercent: shares ? Math.round((100 - proteinPercent - carbsPercent) * 10) / 10 : null
  }));
};
var nutritionPlanTargetsValid = exports.nutritionPlanTargetsValid = function nutritionPlanTargetsValid(plan) {
  return !(plan.mesocycles || []).some(function (meso) {
    return nutritionTargetsError(meso.targets || {});
  });
};
var compositionNutrition = exports.compositionNutrition = function compositionNutrition(parts) {
  return sumNutrition(parts.map(function (part) {
    var quantity = nutritionNumber(part.quantityG);
    var basis = nutritionNumber(part.basisG);
    return scaleNutrition(part.values, quantity > 0 && basis > 0 ? quantity / basis : NaN);
  }));
};
var recipeCompositionNutrition = exports.recipeCompositionNutrition = function recipeCompositionNutrition(rows, ingredients, servings, servingWeightG) {
  var byId = new Map(ingredients.map(function (ingredient) {
    return [String(ingredient.id), ingredient];
  }));
  var totals = compositionNutrition(rows.map(function (row) {
    return {
      quantityG: row.quantityG,
      basisG: 100,
      values: ingredientNutrition(byId.get(String(row.ingredientId)))
    };
  }));
  var count = nutritionNumber(servings) > 0 ? Number(servings) : 1;
  var weights = rows.map(function (row) {
    return nutritionNumber(row.quantityG);
  });
  var ingredientWeightG = rows.length && weights.every(function (weight) {
    return weight > 0;
  }) ? weights.reduce(function (sum, weight) {
    return sum + weight;
  }, 0) : null;
  var explicitWeight = nutritionNumber(servingWeightG);
  var weightG = explicitWeight > 0 ? explicitWeight * count : ingredientWeightG;
  return {
    totals: totals,
    weightG: weightG,
    ingredientWeightG: ingredientWeightG,
    servings: count,
    perServing: scaleNutrition(totals, 1 / count),
    per100g: scaleNutrition(totals, weightG > 0 ? 100 / weightG : NaN)
  };
};
var mealCompositionNutrition = exports.mealCompositionNutrition = function mealCompositionNutrition(rows, ingredients, recipes) {
  var ingredientById = new Map(ingredients.map(function (item) {
    return [String(item.id), item];
  }));
  var recipeById = new Map(recipes.map(function (item) {
    return [String(item.id), item];
  }));
  return compositionNutrition(rows.map(function (row) {
    var isIngredient = row.ingredientId !== undefined && row.ingredientId !== null;
    var recipe = recipeById.get(String(row.recipeId));
    var count = nutritionNumber(recipe === null || recipe === void 0 ? void 0 : recipe.servings) > 0 ? Number(recipe.servings) : 1;
    return {
      quantityG: row.quantityG,
      basisG: isIngredient ? 100 : nutritionNumber(recipe === null || recipe === void 0 ? void 0 : recipe.servingWeightG) > 0 ? Number(recipe.servingWeightG) * count : null,
      values: isIngredient ? ingredientNutrition(ingredientById.get(String(row.ingredientId))) : recipe
    };
  }));
};

// A scheduled meal occurrence is one full meal; duplicate occurrences count again.
// Empty days contribute zero, and averages always include every day of the pattern.
var nutritionScheduleTotals = exports.nutritionScheduleTotals = function nutritionScheduleTotals(days, lengthDays, meals) {
  var byId = new Map(meals.map(function (meal) {
    return [String(meal.id), meal];
  }));
  var zeros = Object.fromEntries(nutritionFields.map(function (field) {
    return [field, 0];
  }));
  var weekdays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  var daily = Array.from({
    length: lengthDays
  }, function (_, index) {
    var slots = days.filter(function (day) {
      return Number(day.dayNumber) === index + 1 || !day.dayNumber && day.weekday === weekdays[index];
    }).flatMap(function (day) {
      return (day.meals || []).length ? day.meals : day.recipeId ? [{
        mealTemplateId: null
      }] : [];
    });
    return _objectSpread({
      dayNumber: index + 1,
      meals: slots.length
    }, slots.length ? sumNutrition(slots.map(function (slot) {
      return byId.get(String(slot.mealTemplateId));
    })) : zeros);
  });
  var total = sumNutrition(daily);
  return {
    daily: daily,
    total: total,
    average: scaleNutrition(total, lengthDays > 0 ? 1 / lengthDays : NaN)
  };
};

// Same sequential/clamped week resolution used by the plan builder and execution.
var nutritionPlanWeeks = exports.nutritionPlanWeeks = function nutritionPlanWeeks(plan) {
  var count = Number(plan.numberOfWeeks);
  if (!Number.isInteger(count) || count < 1) return [];
  return Array.from({
    length: count
  }, function (_, index) {
    var _meso$weekFrom;
    var weekNumber = index + 1;
    var meso = (plan.mesocycles || []).find(function (phase) {
      var _phase$weekFrom, _ref, _phase$weekTo;
      return ((_phase$weekFrom = phase.weekFrom) !== null && _phase$weekFrom !== void 0 ? _phase$weekFrom : 1) <= weekNumber && weekNumber <= ((_ref = (_phase$weekTo = phase.weekTo) !== null && _phase$weekTo !== void 0 ? _phase$weekTo : phase.weekFrom) !== null && _ref !== void 0 ? _ref : 1);
    });
    var micros = (meso === null || meso === void 0 ? void 0 : meso.micros) || [];
    var micro = micros[Math.min(Math.max(weekNumber - ((_meso$weekFrom = meso === null || meso === void 0 ? void 0 : meso.weekFrom) !== null && _meso$weekFrom !== void 0 ? _meso$weekFrom : 1), 0), micros.length - 1)];
    return {
      weekNumber: weekNumber,
      phaseName: (meso === null || meso === void 0 ? void 0 : meso.name) || '',
      targets: (meso === null || meso === void 0 ? void 0 : meso.targets) || {},
      days: micros.length ? (micro === null || micro === void 0 ? void 0 : micro.days) || [] : (meso === null || meso === void 0 ? void 0 : meso.days) || []
    };
  });
};
var nutritionPlanTotals = exports.nutritionPlanTotals = function nutritionPlanTotals(weeks, meals) {
  var weekly = weeks.map(function (week) {
    return _objectSpread(_objectSpread({}, week), nutritionScheduleTotals(week.days, 7, meals));
  });
  var total = sumNutrition(weekly.map(function (week) {
    return week.total;
  }));
  var average = scaleNutrition(total, weeks.length > 0 ? 1 / (weeks.length * 7) : NaN);
  var targetKeys = {
    caloriesKcal: 'kcal',
    proteinG: 'proteinG',
    carbG: 'carbsG',
    fatG: 'fatG'
  };
  // Each phase's daily goal is weighted by its actual weeks, not phase count.
  var averageTargets = scaleNutrition(sumNutrition(weeks.map(function (week) {
    return Object.fromEntries(nutritionFields.map(function (field) {
      var _resolveNutritionTarg;
      return [field, targetKeys[field] ? nutritionNumber((_resolveNutritionTarg = resolveNutritionTargets(week.targets)) === null || _resolveNutritionTarg === void 0 ? void 0 : _resolveNutritionTarg[targetKeys[field]]) : null];
    }));
  })), weeks.length > 0 ? 1 / weeks.length : NaN);
  return {
    weekly: weekly,
    total: total,
    average: average,
    averageTargets: averageTargets
  };
};
